import dynamic from 'next/dynamic'

import { useCustomDesign } from '@/components/styles/useCustomDesign'
import { Page } from '@/core/architecture'

import { ArtistStoreTemplate } from './template'
import { useViewModel } from './viewModel'

const artistStoreCustomDesignMap: Record<string, any> = {
  'ArtistStore_tmpl0001_v1.0': dynamic(
    () => import('@/components/customTemplates/ArtistStore/tmpl0001_v1.0')
  ),
}

export const ArtistStore: Page = () => {
  const { state, actions } = useViewModel()
  const { customDesign } = useCustomDesign({
    type: 'ArtistStore',
    artistId: state.artistId,
  })

  if (!customDesign) return null

  const CustomTemplate = customDesign?.templateId
    ? artistStoreCustomDesignMap[customDesign?.templateId] ??
      ArtistStoreTemplate
    : ArtistStoreTemplate

  return (
    <CustomTemplate
      state={state}
      {...actions}
      customDesign={customDesign?.templateId ? customDesign : undefined}
    />
  )
}
